import { render, staticRenderFns } from "./stakingDetail.vue?vue&type=template&id=44d5c6cd&scoped=true&"
import script from "./stakingDetail.vue?vue&type=script&lang=js&"
export * from "./stakingDetail.vue?vue&type=script&lang=js&"
import style0 from "./stakingDetail.vue?vue&type=style&index=0&id=44d5c6cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d5c6cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44d5c6cd')) {
      api.createRecord('44d5c6cd', component.options)
    } else {
      api.reload('44d5c6cd', component.options)
    }
    module.hot.accept("./stakingDetail.vue?vue&type=template&id=44d5c6cd&scoped=true&", function () {
      api.rerender('44d5c6cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/mining/staking/stakingDetail.vue"
export default component.exports